// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_7dd23ea","input":"_5ec05e4","icon":"_16b0b11","label":"_8248f29","name":"_200ad9d","checked":"_4d182d6"};